<template>
  <div v-if="item">

      <h4>{{item.name}}</h4>

    <fields-list :item="item" :fields="fields" />

   <div class="save-group">
          <button class="btn btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "purchases",
    cardSetLink: "purchases",
    item: null,
    fields: [
         {
              col:' col-12 col-md-8',
              key: "name",
              label: "Название товара",
              type: "field",
              textType: "text",
              readonly: true,
          },
         {
              col:' col-12 col-md-4',
              key: "barcode",
              label: "Баркод",
              type: "field",
              textType: "text",
              readonly: true,
          },
         {
              col:' col-12 col-md-8',
              key: "price",
              label: "Цена",
              type: "field",
                            readonly: true,
              textType: "number",
          },
         {
              col:' col-12 col-md-4',
              key: "quantity",
              label: "Количство",
              type: "field",
              textType: "number",
          },
      
        
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
